<template>
	<section class="home-top-opportunities" ref="top_opportunities">
		<div class="container mx-auto px-4" :class="viewAllClass">

      <div class="home-top-opportunities__header">
        <h3 class="home-top-opportunities__title"><slot name="title"></slot></h3>
        <button @click="viewAll" class="home-top-opportunities__view-all btn btn-border--blue btn-medium btn-rounded">{{ btnTitle }}</button>
      </div>

      <block-top-opportunities-cards :payload="payload"></block-top-opportunities-cards>

      <div class="home-top-opportunities__btn-group">
        <a class="btn btn-blue-dark" href="/search/discover" aria-label="Discover all opportunities">Discover all opportunities</a>
      </div>

		</div>
	</section>
</template>

<script>
export default {

	props: {
		payload: {
			type: [Object, Array, String]
		}
	},

  data() {
    return {
      isActive: false,
      btnTitle: 'View All'
    }
  },

  mounted() {

  },

  methods: {
    viewAll() {
      this.isActive = !this.isActive;
      this.changeBtnTitle();
    },
    changeBtnTitle() {
      setTimeout(() => {
        this.btnTitle = this.isActive ? 'Close' : 'View All';
      }, 250);
    }
  },

  computed: {
    viewAllClass() {
      return this.isActive ? 'view-all' : '';
    }
  }
}
</script>
